import { render, staticRenderFns } from "./esgManagementPoint.vue?vue&type=template&id=5b0ba83c"
import script from "./esgManagementPoint.vue?vue&type=script&lang=js"
export * from "./esgManagementPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b0ba83c')) {
      api.createRecord('5b0ba83c', component.options)
    } else {
      api.reload('5b0ba83c', component.options)
    }
    module.hot.accept("./esgManagementPoint.vue?vue&type=template&id=5b0ba83c", function () {
      api.rerender('5b0ba83c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/esg/esgManagementPoint.vue"
export default component.exports